import { EpimsBaseEntityDto } from './epim-base.dto';
export class IPStatusDto extends EpimsBaseEntityDto {

    IPStatusId: string;

    IPStatusName: string;
    length : number;
    SubscriptionUserId: string;
}